import styled from 'styled-components';
import { clickableStyle } from '@atomic/obj.mixin';
export const ClickableIcon = styled.button `
  background-color: transparent;
  border: 0;
  display: flex;
  ${clickableStyle}
`;
